import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {CollectionParams} from "../../helpers/params/collection-params";
import {PageParams} from "../../helpers/params/page-params";
import {IDocument} from "../../interfaces/document.definition";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {Subject} from "rxjs/Subject";


@Component({
  selector: 'nv-page',
  templateUrl: './nv-page.component.html',
  styles: []
})
export class NvPageComponent implements OnInit, OnDestroy {
  @Input() collectionParams: CollectionParams;
  @Input() pageParams: PageParams;

  document: IDocument;

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private busService: BusService) {
  }

  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.updateDocument(e));
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  getDocumentLabel(item: IDocument): string {
    return this.collectionParams.processItemLabel(item);
  }

  private updateDocument(e: INewDocumentEvent) {
    this.document = e.document;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-page/nv-page.component.ts